import { OpenArArgs } from './webView/types';
import { openARCommand } from './webView/commands';
import { sendCommand } from './webView/sendCommand';

export const openAR = (urls: OpenArArgs) => {
  sendCommand(openARCommand(urls));
};
